import { Grid } from '@material-ui/core';
import { State } from '@progress/kendo-data-query';
import { DateTimePicker } from '@progress/kendo-react-dateinputs';
import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../core/store';
import * as settings from '../../hooks/useSettings';
import useStyles from '../../styles/useStyles';
import AsiteSyncLogsGrid from './AsiteSyncLogsGrid';
import getDefaultGridState from '../../../core/types/common/DefaultGridState';
import { useToastify } from '../../../../Hooks';
const AsiteSyncLogs: React.FC<any> = () => {
    const classes = useStyles();
    const dispatch = useAppDispatch();

    const { showToastError } = useToastify();

    const [startDate, setStartDate] = useState(useAppSelector(settings.selectors.getStartDate));
    const [endDate, setEndDate] = useState(useAppSelector(settings.selectors.getEndDate));
    const [gridState, setGridState] = useState<State>(getDefaultGridState());
    useEffect(() => {
        setGridState(getDefaultGridState());
    }, [startDate, endDate]);

    const handleOnChangeStartDate = (date: Date | null) => {
        if (date === null) {
            setStartDate(undefined);
        } else {
            if (date!.getDate() < 1) return;
            if (date!.getFullYear() < 1) return;
            setStartDate(date);
        }
    };

    const refreshGridWithNewStartDate = () => {
        if (startDate === undefined) {
            dispatch(settings.actions.setStartDate(undefined));
        } else {
            if (endDate !== undefined) {
                if (startDate > endDate) {
                    showToastError('Start date must be equal or lower than End Date!');
                    return;
                }
            }
            dispatch(settings.actions.setStartDate(startDate));
        }
    };

    const handleOnChangeEndDate = (date: Date | null) => {
        if (date === null) {
            setEndDate(undefined);
        } else {
            setEndDate(date);
        }
    };

    const refreshGridWithNewEndDate = () => {
        if (endDate === undefined) {
            dispatch(settings.actions.setEndDate(undefined));
        } else {
            if (startDate !== undefined) {
                if (startDate > endDate) {
                    dispatch(settings.actions.setEndDate(endDate));
                    showToastError('End date must be equal or greater than Start Date!');
                    return;
                }
            }
            dispatch(settings.actions.setEndDate(endDate));
        }
    };

    return (
        <Grid style={{ display: 'flex', flexDirection: 'column' }}>
            <Grid item xs={2} style={{ display: 'flex', flexDirection: 'row' }}>
                <Grid item>
                    <span style={{ marginLeft: '8px' }}>Start Date</span>
                    <DateTimePicker
                        className={classes.dateTimePicker}
                        format={'dd/MM/yyyy HH:mm'}
                        value={startDate}
                        onChange={(e) => handleOnChangeStartDate(e.value)}
                        onBlur={() => refreshGridWithNewStartDate()}
                    />
                </Grid>
                <Grid item>
                    <span>End Date</span>
                    <DateTimePicker
                        format={'dd/MM/yyyy HH:mm'}
                        value={endDate}
                        min={startDate}
                        onChange={(e) => handleOnChangeEndDate(e.value)}
                        onBlur={() => refreshGridWithNewEndDate()}
                    />
                </Grid>
            </Grid>
            <Grid item xs={12} className={classes.syncLogsGrid}>
                <AsiteSyncLogsGrid gridState={gridState} setGridState={setGridState} />
            </Grid>
        </Grid>
    );
};

export default AsiteSyncLogs;
